import React from 'react';
import { circleColor, IconProps, strokeColor } from './icons.utils';

export const AccountIcon: React.FC<IconProps> = ({
  active,
  className = '',
}: IconProps): JSX.Element => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="12" cy="12" r="12" fill={circleColor(active)} />
      <circle cx="12" cy="12" r="12" fill={circleColor(active)} />
      <path
        d="M6.29834 17.1602C6.29834 15.245 7.85094 13.6924 9.76616 13.6924H14.234C16.1492 13.6924 17.7018 15.245 17.7018 17.1602C17.7018 17.5949 17.3494 17.9473 16.9147 17.9473H7.08547C6.65075 17.9473 6.29834 17.5949 6.29834 17.1602Z"
        stroke={strokeColor(active)}
        strokeWidth="2"
      />
      <circle
        cx="12.0002"
        cy="8.67154"
        r="2.6188"
        stroke={strokeColor(active)}
        strokeWidth="2"
      />
    </svg>
  );
};
